// Wave UX-2.4 #26 (2026-05-24) — 외부 바이어 공개 설정 fetch + sessionStorage 캐시.
//
// 사용: DevicePolicyBanner / AuctionBuyerMe 등에서 useDeviceConfig() 호출.
// 캐시: 5분 TTL — 정책 변경 시 사용자가 새로고침 한 번에 즉시 반영.

import { useEffect, useState } from 'react';
import { API } from '../../utils/api';

var CACHE_KEY = 'autodex_buyer_public_config';
var CACHE_TTL_MS = 5 * 60 * 1000;

function loadCached() {
  try {
    var raw = sessionStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    var parsed = JSON.parse(raw);
    if (!parsed || !parsed.t || (Date.now() - parsed.t) > CACHE_TTL_MS) return null;
    return parsed.data;
  } catch (e) { return null; }
}

function saveCached(data) {
  try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), data: data })); } catch (e) { /* silent */ }
}

export function useDeviceConfig() {
  var [config, setConfig] = useState(loadCached());

  useEffect(function() {
    if (config) return;
    fetch(API + '/buyer-app/public/config')
      .then(function(r){ return r.json(); })
      .then(function(d){
        if (d && d.success && d.data) {
          saveCached(d.data);
          setConfig(d.data);
        }
      })
      .catch(function(){ /* silent — 안내 못 보여도 핵심 기능 영향 없음 */ });
  }, [config]);

  return config; // null (로딩 중) 또는 { oneDeviceEnabled }
}
